import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { strings } from '../../lang';
import { Header } from '../header/header';
import './access-denied-page.css';

const AccessDeniedPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoToBooking = () => {
    navigate('/booking');
  };

  return (
    <div className="access-denied-page">
      <Header />
      <div className="access-denied-container">
        <div className="access-denied-content">
          <div className="access-denied-logo">
            <img src="/enpal-logo.png" alt="Enpal Logo" className="enpal-logo" />
          </div>
          <div className="access-denied-text">
            <h1 className="access-denied-title">{strings.accessDenied.title}</h1>
            <p className="access-denied-message">
              {strings.accessDenied.message}
            </p>
            <Button 
              type="primary" 
              icon={<HomeOutlined />} 
              onClick={handleGoToBooking}
              size="large"
              className="go-home-button"
            >
              {strings.accessDenied.goToBooking}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessDeniedPage;
